import Sovet_1 from '../images/sovet/sovet_1.png'
import Sovet_2 from '../images/sovet/sovet_2.png'
import Sovet_3 from '../images/sovet/sovet_3.png'
import Sovet_4 from '../images/sovet/sovet_4.png'
import Sovet_41 from '../images/sovet/sovet_41.jpg'
import Sovet_42 from '../images/sovet/sovet_42.jpg'
import Sovet_43 from '../images/sovet/sovet_43.jpg'
import Sovet_44 from '../images/sovet/sovet_44.jpg'
import Sovet_45 from '../images/sovet/sovet_45.jpg'
import Sovet_46 from '../images/sovet/sovet_46.jpg'
import Sovet_47 from '../images/sovet/sovet_47.jpg'
import Sovet_48 from '../images/sovet/sovet_48.jpg'

const Awards2024 = () => {

    const councilMembers = [
        {
          name: "Олег Иванов",
          title: "Россия",
          description:
            "Руководитель в сфере технологий, разрабатывает инновационные решения для бизнес-процессов.",
          image: Sovet_1,
        },
        {
          name: "Лейла Гусейнова",
          title: "Азербайджан",
          description:
            "Эксперт в области финансовых инвестиций, поддерживает крупные международные проекты.",
          image: Sovet_2, 
        },
        {
            name: "Диана Платонова",
            title: "Молдова",
            description:
              "Профессионал в области экологии и устойчивого развития, активно занимается проектами по защите окружающей среды.",
            image: Sovet_3, 
          },
          {
            name: "Азамат Нуриев",
            title: "Казахстан",
            description:
              "Специалист в области туризма и гостеприимства, занимается развитием туристической инфраструктуры.",
            image: Sovet_4, 
          },
          {
            name: "Марина Соколова",
            title: "Россия",
            description:
              "Эксперт в области международного бизнеса, специализируется на развитии экспортных проектов и масштабировании компаний на зарубежных рынках.",
            image: Sovet_41,
          },
          {
            name: "Виктор Дроздов",
            title: "Беларусь",
            description:
              "Специалист в сфере строительства и девелопмента, курирует проекты по развитию коммерческой и городской инфраструктуры.",
            image: Sovet_42,
          },
          {
            name: "Ирина Коваль",
            title: "Украина",
            description:
              "Эксперт в области ритейла и электронной коммерции, занимается внедрением современных торговых технологий и развитием клиентского сервиса.",
            image: Sovet_43,
          },
          {
            name: "Артем Иванов",
            title: "Украина",
            description:
              "Инженер и разработчик транспортных технологий, специализируется на создании инновационных инженерных решений для транспортной отрасли.",
            image: Sovet_44,
          },
          {
            name: "Тимур Абдуллаев",
            title: "Узбекистан",
            description:
              "Эксперт в области цифровых технологий и инноваций, реализует проекты по внедрению современных технологических решений в различных отраслях экономики.",
            image: Sovet_45,
          },
          {
            name: "Елена Миронова",
            title: "Россия",
            description:
              "Специалист в сфере ресторанного бизнеса, консультирует проекты по развитию современных гастрономических концепций и повышению качества сервиса.",
            image: Sovet_46,
          },
          {
            name: "Сергей Бондаренко",
            title: "Украина",
            description:
              "Эксперт в области спортивного менеджмента, занимается развитием спортивной инфраструктуры и предпринимательских проектов в сфере активного образа жизни.",
            image: Sovet_47,
          },
          {
            name: "Анна Кравченко",
            title: "Казахстан",
            description:
              "Психолог и эксперт по личностному развитию, реализует образовательные и предпринимательские проекты, направленные на развитие эмоционального благополучия и профессионального роста.",
            image: Sovet_48,
          },
      ];

  return (
    <>
    <div
      id="rec273843032"
      className="r t-rec t-rec_pt_0 r_showed r_anim"
      style={{ paddingTop: '0px' }}
      data-record-type="396"
    >
 
      <div className="t396 ">

<div
  className="t396__artboard rendered"
  style={{
    display: "flex",
    alignItems: "center", 
    justifyContent: "center", 
    height: "100vh", 
    position: "relative", 
  }}
>
  <div className="t396__carrier" data-artboard-recid="273843032"></div>
  <div className="t396__filter" data-artboard-recid="273843032"></div>
  <div
    className="t396__elem tn-elem tn-elem__2738430321580382659338"
    data-elem-id="1580382659338"
    data-fields="img,width,filewidth,fileheight,top,left,container,axisx,axisy,widthunits,leftunits,topunits"
    style={{
      position: "absolute",
      width: "920px",
      left: '1023px'
    }}
  >
    <div className="tn-atom">
      <img
        className="tn-atom__img t-img loaded"
        data-original="https://static.tildacdn.com/tild3663-3664-4561-a135-366666386138/ball.png"
        alt=""
        imgfield="tn_img_1580382659338"
        src="https://optim.tildacdn.com/tild3663-3664-4561-a135-366666386138/-/format/webp/ball.png"
      />
    </div>
  </div>
  <div
    className="t396__elem tn-elem tn-elem__2738430321611649501161"
    data-elem-id="1611649501161"
    data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
    style={{ top: '300px', left: '460px', width: '320px' }}
  >
    <div
      className="tn-atom"
      field="tn_text_1611649501161"
      style={{ lineHeight: "18px", textAlign: "start" }}
    >
      ЭКСПЕРТНЫЙ СОВЕТ 2024 ГОДА
    </div>
  </div>
  <div
    className="t396__elem tn-elem tn-elem__2738430321611649583847"
    data-elem-id="1611649583847"
    data-elem-type="text"
    data-fields="top,left,width,container,axisx,axisy,widthunits,leftunits,topunits"
    style={{
      position: "absolute",
      width: "500px",
      textAlign: "start",
      top: "350px",
      left: '450px'

    }}
  >
    <div
      className="tn-atom"
      field="tn_text_1611649583847"
      style={{ lineHeight: "122px" }}
    >
      ЭКСПЕРТНЫЙ СОВЕТ
    </div>
  </div>
  <div
    className="t396__elem tn-elem tn-elem__2738430321611649933808 t-animate t-animate_started"
    data-elem-id="1611649933808"
    data-field-widthunits-res-960-value="%"
    data-fields="width,height,top,left,container,axisx,axisy,widthunits,heightunits,leftunits,topunits"
    style={{
      position: "absolute",
      width: "1157px",
      height: "2px",
      bottom: "50px",
      transform: "translate3d(0px, -100px, 0px)",
      transitionDuration: "1s",
    }}
  >
    <div className="tn-atom"></div>
  </div>
</div>

      </div>
    </div>

    <div className="t-section__title t-title t-title_xs t-align_center t-margin_auto bg-color" field="btitle"> <div  style={{color: '#ffffff'}} data-customstyle="yes"><span style={{fontWeight: '400',}}>ЭКСПЕРТНЫЙ СОВЕТ 2024 ГОДА</span></div> </div>

    <div style={{ backgroundColor: "#1d1c21", color: "#ffffff", padding: "50px 20px" }}>
      <div className="t-container">
        {councilMembers.map((member, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "20px",
              marginBottom: "40px",
              borderBottom: "1px solid #333",
              paddingBottom: "20px",
            }}
          >
            <div
              style={{
                flex: "0 0 130px",
                height: "130px",
                borderRadius: "50%",
                overflow: "hidden",
                backgroundColor: "#444",
              }}
            >
              <img
                src={member.image}
                alt={member.name}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
            <div style={{ flex: "1" }}>
              <div className="t522__persname">{member.name}</div>
              <div className="t522__persdescr">
                {member.title}
              </div>
              <p className="t522__title" >
                {member.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default Awards2024;
